import { getAllPayeh } from '@/api/payeh'
export default {
    state: {
        payeh: [],

    },

    mutations: {

        SET_PAYEHHA: (state, data) => {
            state.payeh = [...data]
        }

    },

    actions: {
        getAllPayeh({ commit }) {
            commit('SET_TABLE_TEXT', true)
            return new Promise((resolve, reject) => {
                getAllPayeh().then(response => {

                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data

                    for (var i = 0; i < data.length; i++) {
                        data[i].Description = ""
                        data[i].Icon = data[i].Status == 'كامل' ? 'check' : 'times'
                    };
                    commit('SET_PAYEHHA', data)
                    commit('SET_TABLE_TEXT', false)

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },


    }
}